<template>
  <div class="addWarninglogin">
    <div class="reply" ref="replayModal">
      <a-modal
        v-model:visible="addVisible"
        :title="title"
        @ok="handleOk"
        :getContainer="() => $refs.replayModal"
        width="60%"
        :afterClose="afterClose"
        wrapClassName="add-modal"
      >
        <a-form :model="formState"  ref="formRef"   :rules="rules" class="form-class">
            <a-form-item ref="name" name="name" label="成员">
                <a-input v-model:value="formState.name" />
            </a-form-item>
            <a-form-item ref="receiveEmail" name="receiveEmail" label="邮箱">
                <a-input v-model:value="formState.receiveEmail" />
            </a-form-item>
            <a-form-item  ref="resource" name="resource" label="接口频次">
                <a-radio-group v-model:value="formState.resource">
                    <a-radio value="1">按自然日</a-radio>
                    <a-radio value="2">按工作日</a-radio>
                </a-radio-group>
            </a-form-item>
              <a-form-item required name="date" label="时段">
                  <a-range-picker
                    :disabledDate="disabledDate"
                    v-model:value="formState.date"
                     @change="panChange"
                    style="width: 100%"
                  />
                 <!-- <a-range-picker
                placeholder="请选择日期"
                v-model:value="formState.date"
                  @change="panChange"
                style="width: 100%"
                /> -->
                </a-form-item>
        </a-form>
      </a-modal>
    </div>
    <a-layout id="components-layout-demo-top" class="layout">
      <headerComponent :showNormal="true"></headerComponent>
      <a-layout-content>
        <a-breadcrumb class="bgCrumb">
          <a-breadcrumb-item @click="qxreturn">首页</a-breadcrumb-item>
          <a-breadcrumb-item @click="qxreturn1">提醒管理</a-breadcrumb-item>
          <a-breadcrumb-item  class="two">
              创建提醒
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="tip">提醒管理</div>
        <div class="dataContent">
      <a-card>
      <div
        class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        基本设置
      </div>
      <a-form  layout="inline" class="form-class">
        <a-form-item  class="form-margin">
        </a-form-item>
        <a-form-item
          label="提醒名称"
          style="margin-left: 0px; margin-top: -30px"
          class="form-margin"
        >
          <a-row>
            <a-col :span="18">
              <a-input
                placeholder="请输入提醒名称"
                style="width: 250px"
                v-model:value="YJname"
              ></a-input>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
          label="目标热榜"
          style="margin-left: 0px"
          class="form-margin"
        >
          <div>
            <a-checkbox
              v-model:checked="state.checkAll"
              :indeterminate="state.indeterminate"
              @change="onCheckAllChange"
              >全选
            </a-checkbox>
            <a-checkbox-group
              v-model:value="state.checkedList"
              :options="plainOptions"
            />
          </div>
        </a-form-item>
         <a-span style="margin-right: 600px; font-size: 14px"
            >预警词
          </a-span>
          <a-textarea
            auto-size
            v-model:value="keyword"
            placeholder="请输入关键词用','分割"
            :rows="2"
            @change="getArr"
            @blur="switchVal1"
            style="width: 40%; margin-right: 280px"
          />
          <br />
          <a-select
            mode="multiple"
            :open="false"
            v-model:value="selectValue"
            @change="handleChange1"
            style="width: 40%"
          >
          <a-select-option v-for="(i,index) in selectArr" :key='index'>
            {{i}}
          </a-select-option>
          </a-select>
           <br />
          <a-span style="margin-right: 610px; font-size: 14px"
            >当前词数:{{ keywordCount }}
          </a-span>
      </a-form>
    </a-card>
    <a-card>
      <div
       class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        接收设置
      </div>
      <a-form layout="inline" class="form-class">
        <a-form-item  class="form-margin">
        </a-form-item>
        <a-table
          :pagination="false"
           bordered
          :data-source="dataSource"
          :columns="columns"
          :loading="loading"
        >
         <template #topReceiveTime="{ text  }">
           {{text=='1'?'按自然日':'按工作日'}}
         </template>
    <template #operation="{ record }">
      <div class="editable-row-operations">
        <span>
          <a class="editName" @click="save(record)">编辑</a>
        </span>
        <a-popconfirm
          v-if="dataSource.length"
          title="确定删除?"
          @confirm="onDelete(record)"
        >
          <a class="editName1"  style="margin: 0px 5px">删除</a>
        </a-popconfirm>
      </div>
    </template>
          <!-- <template #operation="{ record }">
            <a-popconfirm
              v-if="dataSource.length"
              title="确定删除?"
              @confirm="onDelete(record.key)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template> -->
        </a-table>
        <br />
        <a-button
          class="editable-add-btn"
          @click="handleAdd"
          style="margin-bottom: 8px"
          >+添加成员</a-button
        >
      </a-form>
    </a-card>
        </div>
        <a-layout-footer style="text-align: center">
               <div class="hoverBottomWapper"> 
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div>
    </div>
        </a-layout-footer>
      </a-layout-content>
    </a-layout>
       <div class="footer1">
      <a-card style="margin-bottom:0">
        <a-row style="margin-left:80%;">
          <a-col style="checked: ref(false)">
            <a-button @click="qxreturn1">取消</a-button>
          </a-col>
          &nbsp;&nbsp;&nbsp;
          <a-col>
            <a-button @click="onCreateYJ"  :loading="loadingBtn" type="primary"> 提交 </a-button>
          </a-col>
        </a-row>
      </a-card>
    </div>
   
  </div>
</template>

<script>
import { addTopNotify,getUserInfo,getHotList} from "../../utils/api";
import { message,Modal } from "ant-design-vue";
import { createVNode } from 'vue';
import  moment  from 'moment';
import { CheckOutlined, EditOutlined,QuestionCircleOutlined } from "@ant-design/icons-vue";
import { cloneDeep } from "lodash-es";
import headerComponent from '../../components/hotHeader'
const checkAge = function(rule,val){
  if(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)){
    return Promise.resolve();
  }else{
    return Promise.reject('邮箱格式不正确');
  }
}

export default {
  components: {
    CheckOutlined,
    EditOutlined,
    headerComponent,
    QuestionCircleOutlined
  },
  data(){
    return{
      addVisible:false,
      times:'',
      YJname:'',
      loadingBtn:false,
      rules:{
        name: [
            { required: true, message: '请输入成员', trigger: 'blur' },
        ],
        receiveEmail: [
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            { validator: checkAge, message: '邮箱格式不正确', trigger: 'blur' },
        ],
        resource: [
            { required: true, message: '请选择来源', trigger: 'blur' },
        ],
        date: [
            { required: true, message: '请选择时段', trigger: 'change', type: 'array'  },
        ],
      },
      userId:'',
      formState:{
          name:'',
          date:undefined,
          resource:'1',
          receiveEmail:'',
          receiveStarTime:'',
          receiveEndTime:''
      },
      loading:false,
      receiveDay:'',
      open:false,
      open2:false,
      editableData:{},
      columns:[
      {
        title: "成员",
        dataIndex: "name",
        key:'name',
        width: "30%",
        slots: {
          customRender: "name",
        },
      },
      {
        title: "邮箱",
        dataIndex: "receiveEmail",
         key:'receiveEmail',
         slots: {
          customRender: "receiveEmail",
        },
      },
       {
        title: "接收频次",
        dataIndex: "topReceiveTime",
         key:'topReceiveTime',
         slots: {
          customRender: "topReceiveTime",
        },
      },
       {
        title: "接收时间段",
        dataIndex: "date",
        key:'date',
        slots: {
          customRender: "date",
        },
      },
      {
        title: "操作",
        dataIndex: "operation",
        slots: {
          customRender: "operation",
        },
      },
    ],
      plainOptions : [
        // "微博",
        // "论坛",
        // "微信",
        // "新闻",
        // "电商评论",
        // "电商内容",
        // "短视频",
        // "综合视频",
        // "问答",
      ],
      dataSource:[],
      receiveTimeStart:'',
      isEdit:false,
      receiveTimeEnd:'',
      selectValue:[],
      keywordCount:0,
      keyword:'',
      kwBrandOpen:false,
      title: '创建成员',
      kwCount:1,
      curKey:0,
      plainOptions1:[ 
        // {code:"mobile_weibo",name:"微博"},
        // {code:"mobile_bbs",name:"论坛"},
        // {code:"mobile_wechat",name:"微信"},
        // {code:"mobile_news",name:"新闻"},
        // {code:"mobile_svideo",name:"短视频"},
        // {code:"mobile_eccm",name:"电商评论"},
        // {code:"mobile_eccn",name:"电商内容"},
        // {code:"mobile_video",name:"综合视频"},
        // {code:"mobile_wenda",name:"问答"}
      ],
      state:{
        indeterminate: true,
        checkAll: false,
        checkedList: [],
      },
      kwBrandCount:1,
      selectArr:[]
    }
  },
  watch:{
    selectValue(newVal,oldVal){
      this.keywordCount = newVal.length
    }
  },
  mounted(){
      let that = this;
      getUserInfo().then(res=>{
        that.userId = res.user.userId
        getHotList().then(res=>{
          res.rows.map((cur,index)=>{
            that.plainOptions1.push({code:cur.id,name:cur.name})
            that.plainOptions.push(cur.name)
          })
        })
      })
      console.log(this.editableData)
  },
  methods:{
    getNextDate(day) {  
      var dd = new Date();
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    disabledDate (current) {
      return current < moment(this.getNextDate(-2))
    },
     afterClose(){
       this.isEdit = false
          this.formState = {
            name:'',
            date:moment|undefined,
            resource:'1',
            receiveEmail:'',
            receiveStarTime:'',
            receiveEndTime:''
          }
    },
    panChange(val,mode){
      this.formState.receiveStarTime = mode[0]
      this.formState.receiveEndTime = mode[1]
    },
    handleOk(){
        let that = this
        this.$refs.formRef.validate().then(() => {
          if(that.isEdit){
            that.dataSource[that.curKey]={
                "key": that.curKey,
                "name": that.formState.name,
                "receiveEndTime":that.formState.receiveEndTime,
                "receiveStarTime":that.formState.receiveStarTime,
                "receiveEmail": that.formState.receiveEmail,
                "topReceiveTime":that.formState.resource,
                "date":that.formState.receiveStarTime+'~'+that.formState.receiveEndTime,
            }
          }else{
            that.dataSource.push({
                "key": that.dataSource.length,
                "receiveEndTime":that.formState.receiveEndTime,
                "receiveStarTime":that.formState.receiveStarTime,
                "name": that.formState.name,
                "receiveEmail": that.formState.receiveEmail,
                "topReceiveTime":that.formState.resource,
                "date":that.formState.receiveStarTime+'~'+that.formState.receiveEndTime,
            })
          }
         
          that.addVisible = false
        })
        .catch((error) => {
          console.log('error', error);
        });
      },
    switchVal1(){
      let find = false;
      let arr = this.selectArr
      for (let i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
              if (arr[i] == arr[j]) { find = true; break;}
          }
          if (find) break;
      }
      if(find){
        message.error('预警词不可重复')
        return
      }
    },
    onCheckAllChange(e){
      Object.assign(this.state, {
        checkedList: e.target.checked ? this.plainOptions : [],
        indeterminate: false,
      });
    },
    handleOpenChange(openStatus){
      this.open = openStatus
    },
    handleAdd(){
      this.isEdit = false
      this.title = '添加成员'
      this.addVisible = true;
    },
    cancel(key){
        delete this.editableData[key];
    },
    save(key){
      let that = this
      that.addVisible = true
      that.curKey = key.key
      that.title = '修改成员'
      this.isEdit = true
      let arr = []
      arr.push(key.date.substring(0,key.date.indexOf('~')))
      arr.push(key.date.substring(key.date.indexOf('~')+1,key.date.length))
      that.formState = {
        "name": key.name,
        "receiveEmail": key.receiveEmail,
        "resource":key.topReceiveTime,
        "date":arr,
        "receiveStarTime":key.date.substring(0,key.date.indexOf('~')),
        "receiveEndTime":key.date.substring(key.date.indexOf('~')+1,key.date.length)
      }
    },
    edit(key){
      let that = this
      this.editableData[key] = cloneDeep(
        that.dataSource.filter((item) => key === item.key)[0]
      );
    },
    handleClose(){
      this.open = false;
      this.open2 = false;
    },
    qxreturn(){
        this.$router.push({ path: "/hotWord" });
    },
    qxreturn1(){
        this.$router.push({ path: "/hotDataList" });
    },
    onCreateYJ(){
       if(this.YJname==''){
        message.info('提醒名称不得为空')
        return
      }
      if(this.keyword==''){
        message.info('预警词不得为空')
        return
      }
      if(this.keyword.split(',').length>50){
        message.info('预警词数不得超出50个')
        return
      }
      if(this.state.checkedList.length==0){
        message.info('目标平台不得为空')
        return
      }
      if(this.dataSource.length==0){
        message.info('接收设置不得为空')
        return
      }
      // if(this.times==''){
      //   message.info('预警频率不得为空')
      //   return
      // }
      // if(this.receiveDay==''){
      //   message.info('接收时段不得为空')
      //   return
      // }
      // if(this.receiveTimeStart==''){
      //   message.info('开始时间不得为空')
      //   return
      // }
      // if(this.receiveTimeEnd==''){
      //   message.info('结束时间不得为空')
      //   return
      // }
      // if(new Date('2020-10-10 '+this.getStr(this.receiveTimeEnd)).getTime()<=new Date('2020-10-10 '+this.getStr(this.receiveTimeStart)).getTime()){
      //   message.info('开始时间不得小于结束时间')
      //   return
      // }
     
   
      // if(this.dataSource.length==0){
      //   message.info('接收邮箱未填写')
      //   return
      // }
      // if(!canSubmit){
      //   message.info('接收邮箱格式不正确')
      //   return
      // }
      let dataSource1 = {}
      // if(this.kwBrandOpen){
      //   dataSource1 = {
      //     keywords:this.keyword,
      //     kwBrandCount:this.kwBrandCount,
      //     kwBrandOpen:this.kwBrandOpen,
      //     kwCount:this.kwCount,
      //     name:this.YJname,
      //     platforms:this.switchVal(this.state.checkedList),
      //     receiveDay:this.receiveDay,
      //     receiveEmail:dataStr,
      //     // times:1,
      //     times:this.times,
      //     receiveTimeBegin:this.getStr(this.receiveTimeStart),
      //     receiveTimeEnd:this.getStr(this.receiveTimeEnd),
      //   }
      // }else{
        dataSource1 = {
            keywords:this.keyword,
            name:this.YJname,
            userId:this.userId,
            topInfoId:this.switchVal(this.state.checkedList),
            followPoint:'1',
            topNotifyParams:this.dataSource,
            // times:1,
            // times:this.times,
            // receiveTimeBegin:this.getStr(this.receiveTimeStart),
            // receiveTimeEnd:this.getStr(this.receiveTimeEnd),
          }
      // }
      // console.log(dataSource1)
      this.loadingBtn = true;
      addTopNotify(dataSource1).then(res=>{
        this.loadingBtn = false;
        if(res.code==200){
          this.$router.push("hotDataList")
        }
      })
    },
    switchVal(val){
      let newArr = [];
      this.plainOptions1.map((cur,index)=>{
        val.map((cur1,index1)=>{
          if(cur1==cur.name){
            newArr.push(cur.code)
          }
        })
      })
      return newArr
    },
    getStr(val){
      return new Date(val).getHours()<10?('0'+new Date(val).getHours()):(new Date(val).getHours()) + ':' +(new Date(val).getMinutes()<10?('0'+new Date(val).getMinutes()):new Date(val).getMinutes())+':'+(new Date(val).getSeconds()<10?('0'+new Date(val).getSeconds()):(new Date(val).getSeconds()))
    },
    returnsy() {
      this.$router.push({ path: "/warningList" });
    },
    onDelete(key){
      this.dataSource.map((cur,index)=>{
        if(cur.key==key.key){
          this.dataSource.splice(index,1)
        }
      })
      this.dataSource.map((cur,index)=>{
        cur.key = index
      })
      console.log(this.dataSource)
      // this.dataSource = this.dataSource.filter((item) => item.key !== key.key);
    },
    handleChange1(val){
      this.keyword = ''
      val.map((cur)=>{
        this.keyword = this.keyword+','+cur
      })
      this.keyword = this.keyword.substring(1,this.keyword.length)
    },
    getArr(){
      this.selectArr = this.keyword.split(',')
      this.selectArr = this.selectArr.filter(function (s) {
          return s && s.trim(); // 注：IE9(不包含IE9)以下的版本没有trim()方法
      });
      this.selectValue = this.selectArr
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/common/modal.scss';
.add-modal {
  .editable-add-btn {
    width: 100%;
    border-style: dashed;
  }
  .ant-input-number {
    width: 150px;
  }
  .middle {
    vertical-align: middle;
  }
}

.addWarninglogin {
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  font-family: 'NotoSansSC',sans-serif;
   .hoverBottomWapper{
    width: 100%;
    background-color: #333;
    padding-bottom: 10px;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
          position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }
  /deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after{
      background-color: #000;
  }
  /deep/.ant-radio-checked .ant-radio-inner{
    border-color: #000;
  }
  /deep/.ant-radio-inner::after{
    background-color: #000;
    width: .08rem;
    height: .08rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  /deep/.ant-checkbox-checked .ant-checkbox-inner{
    background-color: #000;
    border-color: #000;
  }
  /deep/.editable-add-btn:hover{
    color: #00f000;
    // background-color: #fff;
    border-color: #00f000;
  }
  /deep/.editable-add-btn:focus{
    color: #00f000;
    // background-color: #fff;
    border-color: #00f000;
  }
  .editName{
    color: #00f000;
  }
  .editName1{
    color: #000;
  }
  /deep/.ant-breadcrumb-link {
    cursor: pointer;
  }
  .two {
    /deep/.ant-breadcrumb-link {
      color: #fff;
      cursor: default;
    }
  }
  /deep/.ant-breadcrumb-link {
    color: #999999;
    font-size: 14px;
  }
 
  /deep/.ant-breadcrumb-separator {
    color: #999999;
    font-size: 14px;
  }
  .editable-add-btn{
    border-style: dashed;
  }
  .dataContent{
    background: #333333;
    // padding: 24px;
    min-height: 280px;
    // width: 82%;
    margin: 0 152px;
    /deep/.ant-card{
      border: 0;
    }
    /deep/.ant-card-body{
      padding: 0;
      .ant-form{
        padding-left: 24px;
      }
    }
  }
  /deep/.ant-layout-footer{
    background-color: #333;
  }
  
  .footer1{
    width: 100%;
    background-color: #333;
    /deep/.ant-card{
       background-color: #000;
       border: 0;
    }
    /deep/.ant-btn-primary{
      background-color: #00f000;
      border-color: #00f000;
    }
  }
  /deep/.ant-layout-content {
    position: relative;
    background: #333333;
    .tip {
      position: absolute;
      top: 95px;
      left: 152px;
      font-size: 32px;
      color: #fff;
    }
   
  }
  // .headerContent{
  //   padding: 20px 84px 50px 84px;
  //   background-color: #fff;
  //   margin-bottom: 30px;
  //   .tip{
  //     font-weight: bold;
  //     font-size: 20px;
  //   }
  //   .ant-breadcrumb > span:last-child{
  //     color: rgba(0, 0, 0, 0.647058823529412);
  //   }
  // }
   /deep/.bgCrumb {
    padding: 40px 116px 67px 152px;
    margin-bottom: 60px;
    font-size: 24px;
    height: 200px;
    font-weight: bold;
    font-family: 'Microsoft Tai Le Bold', 'Microsoft Tai Le', sans-serif;
    background-color: #fff;
    background-image: url('../../assets/image/dd.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0 0px;
    color: #fff;
  }
  /deep/.ant-breadcrumb-separator{
    font-size: 14px;
  }
  /deep/.ant-card{
    margin-bottom: 50px;
  }
  .ant-switch{
    margin-left: 20px;
  }
  // /deep/.ant-breadcrumb-link{
  //   font-size: 24px;
  // }
  /deep/.ant-form-inline .ant-form-item > .ant-form-item-control-wrapper, .ant-form-inline .ant-form-item > .ant-form-item-label{
    display: block;
    text-align: left;
  }
  .seting{
    font-weight: bold;
    padding: 24px;
    color: #fff;
    background-color: #000;
  }
}
.cur{
  cursor: pointer;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: black;
  height: 64px;
  width: 100%;
  margin-top: -60px;
  margin-bottom: 20px;
  .image-class {
    width: 170px;
    height: 75px;
    margin: auto 200px;
  }
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    & > span {
      color: rgb(218, 216, 216);
      margin-left: 20px;
      margin-right: 40px;
    }
  }
}
.form-class {
  display: flex;
  flex-direction: column;
}
.form-margin {
  margin: 25px 0;
}
</style>